export const appOnSelectMenu = 'APP-ON-SELECT-MENU';
export const appToggleMenuCollapse = "APP-TOGGLE-MENU-COLLAPSE";
export const appUpdateConfigParams = "APP_UPDATE_CONFIG_PARAMS";

export const authUpdateLaborCategories = "AUTH_UPDATE_LABOR_CATEGORIES";

export const actSetAuthInfo = "act-set-auth-info";
export const actSetLaborInfo = "act-set-labor-info";
export const actSignOut = "act-set-sign-out";

export const cncChangePage = 'CNC_CHANGE_PAGE';
export const cncGetMachineData = 'CNC_GET_MACHINE_DATA';
export const cncSetAllCustomerInfo = "CNC_SET_ALL_CUSTOMER_INFO";
export const cncUpdateCustomerInfo = 'CNC_UPDATE_CUSTOMER_INFO';
export const cncUpdateMachineListInfo = 'CNC_UPDATE_MACHINE_LIST_INFO';
export const cncUpdateMachineDetailInfo = 'CNC_UPDATE_MACHINE_DETAIL_INFO';
export const cncUpdateGroupMachineInfo = "CNC_UPDATE_GROUP_MACHINE_INFO";
export const utilizationData = 'UTILIZATION_DATA';
export const cwUpdateDashboards = "CW_UPDATE_DASHBOARDS";
export const cwUpdateWidgets = "CW_UPDATE_WIDGETS";

export const timeSavingGetList = "TIME_SAVING_GET_LIST";


export const sensorUpdateSensorList = 'SENSOR_UPDATE_SENSOR_LIST';
export const sensorUpdateSensorInfo = 'SENSOR_UPDATE_SENSOR_INFO';
export const sensorChangePage = 'SENSOR_CHANGE_PAGE';
export const sensorAddNewSensor = 'SENSOR_ADD_NEW_SENSOR';
export const sensorUpdateSensor = 'SENSOR_UPDATE_SENSOR';
export const sensorDeleteSensor = "SENSOR_DELETE_SENSOR";


export const hennigUpdateHennigList = "HENNIG_UPDATE_HENNIG_LIST";
export const hennigUpdateHennigInfo = "HENNIG_UPDATE_HENNIG_INFO";
export const hennigChangePage = "HENNIG_CHANGE_PAGE";
export const hennigAddNewHennig = "HENNIG_ADD_NEW_HENNIG";
export const hennigUpdateHennig = "HENNIG_UPDATE_HENNIG";
export const hennigDeleteHennig = "HENNIG_DELETE_HENNIG";

export const setLang = "SET-CURRENT-LANGUAGE";